import { render, staticRenderFns } from "./DataAssetForListSearch.vue?vue&type=template&id=488adb72&scoped=true"
import script from "./DataAssetForListSearch.vue?vue&type=script&lang=js"
export * from "./DataAssetForListSearch.vue?vue&type=script&lang=js"
import style0 from "./DataAssetForListSearch.vue?vue&type=style&index=0&id=488adb72&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "488adb72",
  null
  
)

export default component.exports